import Vue from "vue";
import Router from "vue-router";
import Splash from "@/layouts/Splash";
import AuthLayout from 'bh-mod/layouts/Auth'
import store from "@/store";
import { VueAppMiddleware } from "bh-mod";
import AppLayout from "bh-mod/layouts/App";
import { message } from 'ant-design-vue';

Vue.use(Router);
const router = new Router({
	base: process.env.BASE_URL,
	mode: "history",
	scrollBehavior() {
		return { x: 0, y: 0 };
	},
	routes: [
		{
			path: "/",
			component: AppLayout,
			meta: { instanceRequired: true, auth: true, hidden: true },
			children: [
				// Dashboards
				{
					path: "/",
					meta: {
						title: "SMS/MMS List",
						sidebar: true,
						dataRequired: true,
					},
					component: () => import("./views/app"),
				},
				{
					path: "/new",
					meta: {
						title: "Create Broadcast",
						sidebar: true,
						dataRequired: true,
					},
					component: () => import("./views/app/broadcast.vue"),
				},
				{
					path: "/edit/:id",
					meta: {
						title: "Edit Broadcast",
						sidebar: true,
						dataRequired: true,
					},
					component: () => import("./views/app/broadcast.vue"),
				},
				{
					path: '/settings',
					meta: {
						title: 'Settings',
						sidebar: true,
						dataRequired: true
					},
					component: () =>
						import('./views/settings/index.vue'),
				},
				{
					path: "/tasks-dashboard",
					meta: {
						title: "Tasks Dashboard",
						sidebar: true,
						dataRequired: true
					},
					component: () => import("bh-mod/components/layout/TopBar/TasksDashboard/allTasks.vue"),
				},
				{
					path: "/notifications",
					meta: {
						title: "All Notifications",
						sidebar: true,
						dataRequired: true,
					},
					component: () => import("bh-mod/components/layout/TopBar/Notifications/notifications.vue"),
				},
			],
		},
		{
			path: "/setup",
			component: Splash,
			meta: { hidden: true, splash: true },
			children: [
				{
					path: "/setup",
					meta: {
						title: "Setup SMS/MMS",
						splashScreen: true,
					},
					component: () => import("./views/setup"),
				},
			],
		},
		{
			path: '/404',
			component: Splash,
			children: [
				{
					path: '/404',
					meta: {
						title: 'Error 404',
					},
					component: () => import('bh-mod/components/common/404.vue'),
				}
			]
		},
		{
			path: '/unauthorized',
			component: AuthLayout,
			children: [
				{
					path: '/unauthorized',
					meta: {
						title: 'Unauthorized',
						unauthorized: true
					},
					component: () => import('bh-mod/components/common/unauthorized.vue'),
				}
			]
		},
		// Other routes...
		{
			// Catch-all route: This will match any invalid route
			path: '*',
			redirect: '/404'
		}
	],
});

let hiveRequested = false;
router.beforeEach(async (to, from, next) => {
	let dataRequired = to.matched.some(record => record.meta.dataRequired)
	let splashScreen = to.matched.some(record => record.meta.splashScreen)
	let unauthorized = to.matched.some(record => record.meta.unauthorized)
	let error = false

	if (!hiveRequested) {
		let response = await VueAppMiddleware(to, store, 'sms')
		error = response.parsed
		hiveRequested = true;
	}

	if (error) {
		if (error === 'User does not have required permission!') {
			return next('/unauthorized')
		}
		return console.error('ERROR', error)
	} else {
		if (unauthorized) {
			return next();
		}

		const seenIntro = store.state.appData.allSettings?.userApp?.options?.seenIntro;
		const getStarted = store.state.appData.getStarted

		if (splashScreen && seenIntro) {
			return next('/')
		} else if (dataRequired && !seenIntro && !getStarted) {
			return next('/setup')
		}

		if (!store.state.appData.activePhoneNumbersLoaded) {
			await store.dispatch('FETCH_ACTIVE_PHONE_NUMBERS');
		}

		if (to.path === '/new') {
			const activePhoneNumbers = store.state.appData.activePhoneNumbers;
			if (!activePhoneNumbers.length) {
				message.error('You don\'t have any phone numbers. Please buy a number first.')
				return next('/settings?tab=buyNumbers')
			}
		}

		next();
	}
	next();
});

export default router;
